import React from 'react';
import classnames from 'classnames';

import * as styles from './SortPill.module.css';

export function SortPill({children, onClick, currentSort, field}) {
  const arrow =
    currentSort.field === field && currentSort.direction === 'ASC' ? (
      <>&darr;</>
    ) : currentSort.field === field && currentSort.direction === 'DESC' ? (
      <>&uarr;</>
    ) : null;

  const classes = classnames(styles.SortPill, arrow != null && styles.Active);

  return (
    <button onClick={() => onClick(field)} className={classes}>
      {children} {arrow}
    </button>
  );
}
